"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), require("cross-fetch/polyfill");

var t,
    e = (t = require("query-string")) && "object" == typeof t && "default" in t ? t.default : t,
    r = require("@formium/types");

function n() {
  return (n = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function o(t) {
  return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function i(t, e) {
  return (i = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function u() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function a(t, e, r) {
  return (a = u() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && i(o, r.prototype), o;
  }).apply(null, arguments);
}

function s(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (s = function s(t) {
    if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, r);
    }

    function r() {
      return a(t, arguments, o(this).constructor);
    }

    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), i(r, t);
  })(t);
}

function c(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var r = 0, n = new Array(e); r < e; r++) {
    n[r] = t[r];
  }

  return n;
}

var f = function (t) {
  var e, r;

  function n(e, r, n) {
    var o;
    if ((o = t.call(this) || this).message = e + " (" + r.status + ")", o.status = r.status, o.serverMessage = e, o.retryAfter = null, n) for (var i = 0, u = Object.keys(n); i < u.length; i++) {
      var a = u[i];
      "message" !== a && (o[a] = n[a]);
    }

    if (429 === r.status) {
      var s = r.headers.get("Retry-After");
      s && (o.retryAfter = parseInt(s, 10));
    }

    return o;
  }

  return r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r, n;
}(s(Error));

function p(t, e, r) {
  return function (n, o) {
    void 0 === o && (o = {});
    var i = o;
    return i.headers = o.headers || {}, i.headers["X-Formik-Client"] = "@formium/client", i.headers["X-Formik-Client-Version"] = "0.1.3", r && (i.headers.Authorization = "Bearer " + r), e(t + n, i).then(function (t) {
      try {
        var e = function e(_e) {
          return r ? _e : Promise.resolve(t.json()).then(function (e) {
            var r,
                o = (null === (r = n = e.error || e.err || e) || void 0 === r ? void 0 : r.message) || "Response Error";
            return Promise.reject(new f(o, t, n));
          });
          var n;
        },
            r = !1,
            n = function () {
          if (t.ok) return t.headers.get("content-type") ? (r = !0, t.headers.get("content-type").includes("application/json") ? Promise.resolve(t.json()) : t) : void (r = !0);
        }();

        return Promise.resolve(n && n.then ? n.then(e) : e(n));
      } catch (t) {
        return Promise.reject(t);
      }
    });
  };
}

var l = function () {
  function t(t, e) {
    var r, n;
    this.projectId = t, this.baseUrl = null !== (r = null == e ? void 0 : e.baseUrl) && void 0 !== r ? r : "https://api.formium.io", this._fetcher = p(this.baseUrl, null !== (n = null == e ? void 0 : e.fetchImplementation) && void 0 !== n ? n : fetch, null == e ? void 0 : e.apiToken);
  }

  var r = t.prototype;
  return r.findForms = function (t, r) {
    var o = "/v1/form?" + e.stringify(n({
      projectId: this.projectId
    }, t));
    return this._fetcher(o, n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, r));
  }, r.getMe = function (t) {
    return this._fetcher("/v1/user/me", n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, t));
  }, r.getProject = function (t, e) {
    return this._fetcher("/v1/project/" + t, n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, e));
  }, r.getMyProjects = function (t) {
    return this._fetcher("/v1/project/me", n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, t));
  }, r.logout = function (t) {
    return this._fetcher("/oauth/token/me", n({
      method: "DELETE"
    }, t));
  }, r.getProjectBySlug = function (t, e) {
    return this._fetcher("/v1/project/slug" + t, n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, e));
  }, r.getFormBySlug = function (t, e, r) {
    var o = "/v1/form/id/" + this.projectId + "/" + t,
        i = n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, r);
    return e && e.revisionId && (i.headers["X-Formik-Revision"] = e.revisionId), this._fetcher(o, i);
  }, r.getSubmit = function (t, e) {
    var r = "/v1/submit/" + t,
        o = n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, e);
    return this._fetcher(r, o);
  }, r.deleteSubmit = function (t, e) {
    var r = "/v1/submit/" + t,
        o = n({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    }, e);
    return this._fetcher(r, o);
  }, r.deleteSubmits = function (t, r) {
    var o = "/v1/submit?" + e.stringify(t),
        i = n({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json"
      }
    }, r);
    return this._fetcher(o, i);
  }, r.findSubmits = function (t, r) {
    var o = "/v1/submit?" + e.stringify(t);
    return this._fetcher(o, n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, r));
  }, r.getFormById = function (t, e, r) {
    var o = "/v1/form/" + t,
        i = n({
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, r);
    return e && e.revisionId && (i.headers["X-Formik-Revision"] = e.revisionId), this._fetcher(o, i);
  }, r.submitForm = function (t, e) {
    var r;

    if (e instanceof FormData) {
      for (var n, o = {}, i = function (t, e) {
        var r;

        if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
          if (Array.isArray(t) || (r = function (t, e) {
            if (t) {
              if ("string" == typeof t) return c(t, void 0);
              var r = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? c(t, void 0) : void 0;
            }
          }(t))) {
            r && (t = r);
            var n = 0;
            return function () {
              return n >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[n++]
              };
            };
          }

          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }

        return (r = t[Symbol.iterator]()).next.bind(r);
      }(e); !(n = i()).done;) {
        var u = n.value,
            a = u[0],
            s = u[1];
        o.hasOwnProperty(a) ? (Array.isArray(o[a]) || (o[a] = [o[a]]), o[a].push(s)) : o[a] = s;
      }

      r = JSON.stringify(o);
    } else r = JSON.stringify(e);

    return this._fetcher("/submit/" + this.projectId + "/" + t, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: r
    });
  }, r.uploadFile = function (t, e) {
    var r = new FormData();
    return r.append("file", e), this._fetcher("/submit/" + this.projectId + "/" + t + "/upload", {
      method: "POST",
      body: r
    }).then(function (t) {
      return t.headers.get("Location");
    });
  }, t;
}();

Object.keys(r).forEach(function (t) {
  "default" !== t && Object.defineProperty(exports, t, {
    enumerable: !0,
    get: function get() {
      return r[t];
    }
  });
}), exports.FormiumClient = l, exports._createFetcher = p, exports.createClient = function (t, e) {
  return new l(t, e);
};